import axios from 'axios'
import {ALTERAR_VEICULO_ITINERARIOS_EM_LOTE} from '../types'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';

export function alterarVeiculoItinerarioEmLote(parametros) {
    const url = `${URL}/itinerario/alterar-veiculo-itinerarios-em-lote`;
    return dispatch => axios.post(url, parametros, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: ALTERAR_VEICULO_ITINERARIOS_EM_LOTE,
            payload: response
        })
    );
}
